<nav>
  <ul class="breadcrumb">
    <li class="breadcrumb-item"><a routerLink="/pre-log"><i class="fa fa-plus-square" style="width: 20px;"></i>Pre-Log Entry</a></li>
    <li class="ms-auto">@if (externalLinks) {
      <a [href]="externalLinks.dataBankResourcesUrl" target="_blank"><i class="fa fa-external-link" style="width: 20px;"></i>DNA Data Bank Resources</a>
    }</li>
  </ul>
</nav>
<div class="text-center">
  <h1>DNA Data Bank Sample Search</h1>
</div>
@if (errorMessage) {
  <div class="col-12 col-lg-6 offset-lg-3 alert alert-danger">{{errorMessage}}</div>
}
<form [formGroup]="searchForm" (ngSubmit)="onSubmit()">
  <div class="row">
    <div class="col-12 col-md-10">
      <div class="row">
        @if (showVACORISNumber) {
          <div class="form-group col-12 col-md-4 col-xl-2">
            <label for="doc-number">VACORIS #</label>
            <input type="text" id="doc-number" #needFocusCORIS formControlName="docNumber" maxlength="11" class="form-control" [class.is-invalid]="docNumber.invalid && docNumber.touched" />
          </div>
        }
        <div class="form-group col-12" [class.col-md-6]="!showVACORISNumber" [class.col-xl-3]="!showVACORISNumber" [class.col-md-4]="showVACORISNumber" [class.col-xl-2]="showVACORISNumber">
          <label for="last-name">Last Name</label>
          <input type="text" id="last-name" #needFocus formControlName="lastName" maxlength="50" class="form-control" [class.is-invalid]="lastName.invalid && lastName.touched" oninput="this.value = this.value.toUpperCase()" />
          @if (lastName.touched && lastName.hasError('minlength')) {
            <small class="text-danger">Last Name must be at least 2 characters (or blank)</small>
          }
        </div>
        <div class="form-group col-12" [class.col-md-6]="!showVACORISNumber" [class.col-xl-3]="!showVACORISNumber" [class.col-md-4]="showVACORISNumber" [class.col-xl-2]="showVACORISNumber">
          <label for="first-name">First Name</label>
          <input type="text" id="first-name" formControlName="firstName" maxlength="25" class="form-control" [class.is-invalid]="firstName.invalid && firstName.touched" oninput="this.value = this.value.toUpperCase()" />
          @if (firstName.touched && firstName.hasError('minlength')) {
            <small class="text-danger">First Name must be at least 2 characters (or blank)</small>
          }
          @if (firstName.touched && searchForm.hasError('dependantRequired')) {
            <small class="text-danger">First Name cannot be entered without Last Name</small>
          }
        </div>
        <div class="form-group col-12" [class.col-md-6]="!showVACORISNumber" [class.col-xl-3]="!showVACORISNumber" [class.col-md-4]="showVACORISNumber" [class.col-xl-2]="showVACORISNumber">
          <label for="ssn">SSN</label>
          <input type="text" id="ssn" mask="000-00-0000" [dropSpecialCharacters]="false" formControlName="ssn" class="form-control" [class.is-invalid]="ssn.touched && ssn.invalid" (keydown.tab)="ssnKeyDown($event)" />
          @if (ssn.touched && ssn.invalid) {
            <small class="text-danger">SSN must be in the format: 000-00-0000</small>
          }
        </div>
        <div class="form-group col-12" [class.col-md-6]="!showVACORISNumber" [class.col-xl-3]="!showVACORISNumber" [class.col-md-4]="showVACORISNumber" [class.col-xl-2]="showVACORISNumber">
          <label for="sid">SID</label>
          <input type="text" id="sid" #sidTextbox formControlName="sid" class="form-control" [class.is-invalid]="sid.invalid && sid.touched" />
        </div>
        @if (!showVACORISNumber && lastName.touched && ssn.touched && sid.touched && searchForm.hasError('anyRequired')) {
          <div class="form-group col-12">
            <small class="text-center text-danger">Either Last Name, SSN, or SID is required</small>
          </div>
        }
        @if (showVACORISNumber && lastName.touched && ssn.touched && sid.touched && docNumber.touched && searchForm.hasError('anyRequired')) {
          <div class="form-group col-12">
            <small class="text-center text-danger">Either Last Name, SSN, SID, or VACORIS # is required</small>
          </div>
        }
        @if (showVACORISNumber && lastName.touched && ssn.touched && sid.touched && docNumber.touched && searchForm.hasError('exclusive')) {
          <div class="form-group col-12">
            <small class="text-center text-danger">When searching by VACORIS #, no other search criteria can be specified</small>
          </div>
        }
      </div>
    </div>
    <div class="col-12 col-md-2 sample-search-button">
      <button [disabled]="!searchForm.valid" type="submit" class="btn btn-primary">Search</button>
      <button type="button" class="btn btn-secondary" (click)="clear()">Clear</button>
      @if (working) {
        <i class="fa fa-spinner fa-spin ms-1"></i>
      }
    </div>
    <div class="col-12">
      @if (searchResults && searchResults.length === 0) {
        <div class="text-center alert alert-warning">There are no samples matching the entered criteria</div>
      }
      @if (showTooManyResultsMessage) {
        <div class="text-center alert alert-warning">The entered criteria matched more than {{ resultCountLimit }} samples, but only the first {{ resultCountLimit }} are displayed. Please refine the search criteria.</div>
      }
      @if (searchResults && searchResults.length > 0) {
        <table class="table table-striped table-responsive-md">
          <thead>
            <tr>
              <th scope="col" sortable="lastName" (sort)="onSort($event)">Last Name</th>
              <th scope="col" sortable="firstName" (sort)="onSort($event)">First Name</th>
              <th scope="col">MI</th>
              @if (showVACORISNumber) {
                <th scope="col">VACORIS #</th>
              }
              <th scope="col">SSN</th>
              <th scope="col" sortable="sid" (sort)="onSort($event)">SID</th>
              <th scope="col" sortable="dateOfBirth" (sort)="onSort($event)">Date of Birth</th>
              <th scope="col" sortable="dateCollected" direction="desc" (sort)="onSort($event)">Date Collected</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            @for (searchResult of searchResults; track searchResult) {
              <tr>
                <td>{{ searchResult.lastName }}</td>
                <td>{{ searchResult.firstName }}</td>
                <td>{{ searchResult.middleInitial }}</td>
                @if (showVACORISNumber) {
                  <td>{{ searchResult.docNumber }}</td>
                }
                <td [innerHtml]="renderSSNs(searchResult.ssns)"></td>
                <td>{{ searchResult.sid }}</td>
                <td>{{ searchResult.dateOfBirth | date: 'M/d/yyyy' }}</td>
                <td>{{ searchResult.dateCollected | date: 'M/d/yyyy' }}</td>
                <td><button type="button" class="btn btn-link" (click)="onDetailsClick(searchResult.id)">Details</button></td>
              </tr>
            }
          </tbody>
        </table>
      }
      @if (searchResults) {
        <div class="text-center alert alert-info">
          If you didn't find the Sample you were looking for, review the Search Tips below and try again with different criteria.<br />
          If a new Sample needs to be collected, use <a routerLink="/pre-log" class="alert-link">Pre-Log Entry</a>.
        </div>
      }
    </div>
    <div class="search-tips">
      <h2>Search Tips</h2>
      @if (showVACORISNumber) {
        <div class="collapsible" [attr.aria-expanded]="!searchTipsVACORISCollapsed" aria-controls="tips-vacoris" (click)="searchTipsVACORISCollapsed = !searchTipsVACORISCollapsed">
          <h3>Search by VACORIS #</h3>
          @if (searchTipsVACORISCollapsed) {
            <i class="fa fa-chevron-right"></i>
          }
          @if (!searchTipsVACORISCollapsed) {
            <i class="fa fa-chevron-down"></i>
          }
        </div>
        <ul id="tips-vacoris" [ngbCollapse]="searchTipsVACORISCollapsed">
          <li>VACORIS # cannot be searched with any other field</li>
          <li>VACORIS # matches values exactly</li>
        </ul>
      }
      <div class="collapsible" [attr.aria-expanded]="!searchTipsNameCollapsed" aria-controls="tips-name" (click)="searchTipsNameCollapsed = !searchTipsNameCollapsed">
        <h3>Search by Name</h3>
        @if (searchTipsNameCollapsed) {
          <i class="fa fa-chevron-right"></i>
        }
        @if (!searchTipsNameCollapsed) {
          <i class="fa fa-chevron-down"></i>
        }
      </div>
      <ul id="tips-name" [ngbCollapse]="searchTipsNameCollapsed">
        <li>First Name can only be included if Last Name is included</li>
        <li>First Name and Last Name require at least 2 characters</li>
        <li>First Name and Last Name match values that start with the entered characters</li>
      </ul>
      <div class="collapsible" [attr.aria-expanded]="!searchTipsSSNSIDCollapsed" aria-controls="tips-ssn-sid" (click)="searchTipsSSNSIDCollapsed = !searchTipsSSNSIDCollapsed">
        <h3>Search by SSN and/or SID</h3>
        @if (searchTipsSSNSIDCollapsed) {
          <i class="fa fa-chevron-right"></i>
        }
        @if (!searchTipsSSNSIDCollapsed) {
          <i class="fa fa-chevron-down"></i>
        }
      </div>
      <ul id="tips-ssn-sid" [ngbCollapse]="searchTipsSSNSIDCollapsed">
        <li>SSN and SID match values exactly</li>
        <li>SID must have State designation at beginning, for example, "VA"</li>
        <li>If SSN and SID are entered, matches on either SSN or SID are returned</li>
      </ul>
      <div class="collapsible" [attr.aria-expanded]="!searchTipsNameSSNSIDCollapsed" aria-controls="tips-name-ssn-sid" (click)="searchTipsNameSSNSIDCollapsed = !searchTipsNameSSNSIDCollapsed">
        <h3>Search by Name, SSN, and/or SID</h3>
        @if (searchTipsNameSSNSIDCollapsed) {
          <i class="fa fa-chevron-right"></i>
        }
        @if (!searchTipsNameSSNSIDCollapsed) {
          <i class="fa fa-chevron-down"></i>
        }
      </div>
      <ul id="tips-name-ssn-sid" [ngbCollapse]="searchTipsNameSSNSIDCollapsed">
        <li>If Name and SSN are entered, matches on Name and SSN are returned</li>
        <li>If Name and SID are entered, matches on Name and SID are returned</li>
        <li>If Name, SSN, and SID are entered, matches on Name and SSN or Name and SID are returned</li>
        <li>A record with no SSN or SID will still be returned if it matches on Name</li>
      </ul>
    </div>
  </div>
</form>
